import { selectUserClientSecret } from "domain/auth/auth.selectors";
import React, { useEffect } from "react";
import { useAppSelector } from "ui/hook/store";

export function StripePricingTable({
  email,
  register,
}: {
  email: string;
  register: boolean;
}) {
  const clientSecret = useAppSelector(selectUserClientSecret);

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://js.stripe.com/v3/pricing-table.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return React.createElement("stripe-pricing-table", {
    "pricing-table-id": register
      ? process.env.REACT_APP_STRIPE_TABLE_ID_REGISTER
      : process.env.REACT_APP_STRIPE_TABLE_ID_ACCOUNT,
    "publishable-key": process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY,
    ...(clientSecret
      ? { "customer-session-client-secret": clientSecret }
      : { "customer-email": email }),
  });
}

export default StripePricingTable;
